export default "__VITE_ASSET__BIYJyjm___"